export const DEFAULT_ROUTE: string = "/chats";
export const ADMIN_DEFAULT_ROUTE: string = "/license";